module.exports = __webpack_public_path__ + "img/113ne.b30754dd.svg";